import { render } from "./DashboardNeedsProfileModal.vue?vue&type=template&id=45ef28bf"
import script from "./DashboardNeedsProfileModal.vue?vue&type=script&lang=js"
export * from "./DashboardNeedsProfileModal.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__